module.exports = __webpack_public_path__ + "static/img/dijia.416d4457.png";